import { CloseIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { putApi } from "common/services/api";
import { getApi } from "common/services/api";
import { generateValidationSchema } from "services/Crm/utils";
import CustomForm from "../../../common/utils/customForm";
import * as yup from "yup";
import { toast } from "react-toastify";
import { singularizeLastWord } from "services/Crm/utils/calcUtils";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";

const Edit = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const initialFieldValues = Object.fromEntries(
    (props?.moduleData?.fields || []).map((field) => [field?.name, ""])
  );
  const [isDataLoding, setIsDataLoding] = useState(false);

  const [initialValues, setInitialValues] = useState({
    ...initialFieldValues,
    createBy: JSON.parse(localStorage.getItem("user"))._id,
  });
  const param = useParams();

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: yup
      .object()
      .shape(generateValidationSchema(props?.moduleData?.fields)),
    onSubmit: (values, { resetForm }) => {
      EditData();
    },
  });

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const EditData = async () => {
    try {
      setIsLoading(true);
      let response = await putApi(
        `api/form/edit/${props?.selectedId || param.id}`,
        { ...values, moduleId: props.moduleId }
      );
      if (response.status === 200) {
        props.onClose();
        props.setAction((pre) => !pre);
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    props.onClose(false);
    props.setSelectedId && props?.setSelectedId();
    formik.resetForm();
  };
  let response;
  const fetchData = async () => {
    if (props?.selectedId || param.id) {
      try {
        setIsDataLoding(true);
        response = await getApi(
          `api/form/view/${props?.selectedId || param.id}?moduleId=${
            props.moduleId
          }`
        );
        let editData = response?.data?.data;
        setInitialValues((prev) => ({ ...prev, ...editData }));
      } catch (e) {
        console.error(e);
      } finally {
        setIsDataLoding(false);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [props?.selectedId]);

  return (
    <div>
      <Box className="modal-main" >
        {/* <DrawerOverlay /> */}
        <Box>
          <Box
            alignItems={"center"}
            justifyContent="space-between"
            display="flex"
          >
            {constant.edit} {singularizeLastWord(props.title)}
            <IconButton onClick={handleClose} icon={<CloseIcon />} />
          </Box>
          <Box>
            {isDataLoding ? (
              <Flex
                justifyContent={"center"}
                alignItems={"center"}
                width="100%"
              >
                <Spinner />
              </Flex>
            ) : (
              <CustomForm
                moduleData={props.moduleData}
                values={values}
                setFieldValue={setFieldValue}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
              />
            )}
          </Box>
          <Box>
            <Button
              sx={{ textTransform: "capitalize" }}
              variant="brand"
              size="sm"
              type="submit"
              disabled={isLoading ? true : false}
              onClick={handleSubmit}
              className="theme-btn1"
            >
              {isLoading ? (
                <Spinner
                  size={20}
                  paddingRight={5}
                  border={`3px solid ${globalStyles.colors.loaderBorder}`}
                  borderTop={`1px solid ${globalStyles.colors.transparent}`}
                />
              ) : (
                ""
              )}{" "}
              {constant.upload}
            </Button>
            <Button
              variant="outline"
              colorScheme="red"
              size="sm"
              sx={{
                marginLeft: 2,
                textTransform: "capitalize",
              }}
              onClick={handleClose}
              className="theme-btn2"
            >
              Close
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Edit;
